import { useStudentPendingSurveysQuery } from 'core/graphql';

import { IPendingSurvey, transformPendingSurveys } from './transform';

interface IUseMySurveys {
  surveys: IPendingSurvey[];
  loading: boolean;
  error: string;
  refetch: () => void;
}

/**
 * The student's pending (not yet submitted) surveys via `mySurveys`. The
 * payload already carries the full question list, so the fill page needs no
 * second request. `cache-and-network` keeps a stale list self-healing: a
 * survey submitted in another tab disappears on the next mount.
 */
export const useMySurveys = (): IUseMySurveys => {
  const { data, loading, error, refetch } = useStudentPendingSurveysQuery({
    fetchPolicy: 'cache-and-network',
  });

  return {
    surveys: transformPendingSurveys(data),
    loading,
    error: error?.message || '',
    refetch,
  };
};
